import { createReducer, on } from '@ngrx/store';
import { RequestStatus } from '../../enums/request-status.enum';
import * as UserDomainsActions from './user-domains.actions';
import { DomainResponse } from '../models/domain-response.model';

export interface UserDomainsState {
  data: {
    domains: DomainResponse[];
    meta: {
      currentPage: number;
      perPage: number;
      total: number;
      totalPages: number;
    } | null;
    status: RequestStatus;
    error: string | null;
  };
}

export const initialState: UserDomainsState = {
  data: {
    domains: [],
    meta: null,
    status: RequestStatus.Idle,
    error: null,
  },
};

export const userDomainsReducer = createReducer(
  initialState,
  on(UserDomainsActions.loadUserDomains, (state) => ({
    ...state,
    data: {
      ...state.data,
      status: RequestStatus.Loading,
      error: null,
    },
  })),
  on(UserDomainsActions.loadUserDomainsSuccess, (state, { domains, meta }) => ({
    ...state,
    data: {
      domains,
      meta,
      status: RequestStatus.Success,
      error: null,
    },
  })),
  on(UserDomainsActions.loadUserDomainsFailure, (state, { error }) => ({
    ...state,
    data: {
      ...state.data,
      status: RequestStatus.Error,
      error,
    },
  }))
);

